import { makeStyles } from "@mui/styles";
import { CardLegend, LegendComponentProps } from "./CardLegend";
import { Donut, DonutProps } from "./Donut";
import ModuleProgressBar, { ModuleProgressBarProps } from "./ModuleProgressBar";

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    borderRadius: "1rem",
    padding: "2rem",
    [theme.breakpoints.down("lg")]: {
      padding: "1rem",
    },
  },
  heading: {
    display: "flex",
    flexDirection: "row",
    color: "#484848",
    marginBottom: "1.8rem",
  },
  headingText: {
    margin: "0 .625rem 0 .75rem",
    font: "normal normal 600 20px/24px proxima-soft",
    letterSpacing: "0px",
    color: "#484848",
  },
  card: {
    display: "flex",
  },
  progressGroup: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "1.3rem",
    alignSelf: "center",
    flex: 1,
    [theme.breakpoints.down("xl")]: {
      marginLeft: "0.5rem",
    },
  },
}));
interface CardProps {
  title: string;
  icon: any;
  donutProps: DonutProps;
  progressBarProps: ModuleProgressBarProps;
  legendProps: LegendComponentProps;
}

export const ProgressCardSmall = (props: CardProps) => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <div className={classes.heading}>
        {props.icon}
        <h2 className={classes.headingText}>{props.title}</h2>
      </div>
      <div className={classes.card}>
        <Donut
          aria-label={props.donutProps["aria-label"]}
          centerValue={props.donutProps.centerValue}
          value={props.donutProps.value}
          label={props.donutProps.label}
          small
        />
        <div className={classes.progressGroup}>
          <ModuleProgressBar {...props.progressBarProps} />
          <CardLegend legendProps={props.legendProps} />
        </div>
      </div>
    </div>
  );
};
